<app-content-wrapper right-class="bgc-white">
  <app-topbar>
    <div app-topbar-title>
      <i class="far fa-user-circle"></i>
      <span>Hi {{ userNameLabel }}</span>
    </div>

    <ng-container *ngIf="hasFocusedVisual()">
      <button trgButton color="outline" class="text-left h-32 min-w-100"
              (click)="clearFocused()">
        <i class="far fa-chevron-left i-12 mr-8"></i>
        <span>Back</span>
      </button>
    </ng-container>

    <div class="d-flex align-items-center" [hidden]="hasFocusedVisual()">
      <div>
        <span class="home-dashboard-dropdown-prefix" [class.disabled]="disableHomeButton">
          <i class="fas fa-home-alt i-13"></i>
        </span>
        <button class="home-dashboard-dropdown h-32 w-250 text-ellipsis" [disabled]="disableHomeButton || !anyHomeItem" [matMenuTriggerFor]="homeSelectionMenu">
          <div class="d-flex ml-30 justify-content-between">
            <span class="text-ellipsis">{{ dropdownText }}</span>
            <i class="fas fa-chevron-down pr-5 p-relative ot-2 c-grey"></i>
          </div>
          <mat-menu #homeSelectionMenu class="p-relative ot-5 home-dashboard-dropdown-panel" xPosition="after" [hasBackdrop]="true">
            <ng-template matMenuContent>
              <app-home-item-selector
                [busy]="false"
                [categories]="dropdownCategories"
                [currentItem]="dropdownItem"
                (itemSelected)="selectItem($event)"
                (close)="homeSelectionMenu.close.emit()"
                click-stop-propagation
              ></app-home-item-selector>
            </ng-template>
          </mat-menu>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <button
          *ngIf="canEdit && !showCopyButton"
          trgButton
          color="dark-outline"
          class="copy text-left ml-16 h-32 lh-32 min-w-70"
          [disabled]="(!selectedDashboardId && !selectedVisualId) || busy || !anyHomeItem"
          (click)="editContent()"
        >
          <div class="d-flex align-items-center">
            <i class="far fa-pencil-alt i-12 mr-4"></i>
            <span>Edit</span>
            <i class="fas fa-user-lock i-12 ml-20" *ngIf="currentItemIsLocked"></i>
          </div>
        </button>

        <button
          *ngIf="showCopyButton"
          trgButton
          color="dark-outline"
          class="copy text-left ml-16 h-32 lh-32 min-w-70"
          [disabled]="(!selectedDashboardId && !selectedVisualId) || busy || !anyHomeItem"
          (click)="copy()"
        >
          <div class="d-flex align-items-center">
            <i class="far fa-pencil-alt i-12 mr-4"></i>
            <span>Copy</span>
          </div>
        </button>

        <button
          *ngIf="showExportToPDFButton"
          trgButton
          color="primary"
          class="text-left ml-16 h-32 lh-32 min-w-100"
          (click)="exportToPdf()"
          [disabled]="!selectedDashboardId || busy || !anyHomeItem"
        >
          <i class="far fa-file-pdf i-12 mr-4"></i>
          <span>Export to PDF</span>
        </button>
        <button
          *ngIf="showVisualExportButton"
          trgButton
          color="primary"
          class="text-left ml-16 h-32 lh-32 min-w-100"
          (click)="exportVisual()"
          [disabled]="!selectedVisualId || busy || !anyHomeItem"
        >
          <i class="far fa-file-pdf i-12 mr-4"></i>
          <span>Export</span>
        </button>
      </div>

      <div *ngIf="dashboard || visual" class="topbar__vertical-line"></div>

      <div *ngIf="dashboard || visual" class="d-inline-flex align-items-center">
        <span class="fs-14 c-text-color-dark mr-8">Name:</span>
        <span class="fs-18 c-blue bold">{{ itemName }}</span>
      </div>
    </div>
  </app-topbar>
  
  <side-panel contentLeft 
              [collapsible]="true"
              [canToggle]="filtersAvailable()"
              [collapsed]="sidePanelCollapse()"
              (collapsedChange)="sidePanelCollapsed.set($event)"
              #sidePanel>
    <side-panel-filter-list #filterList
                            [mode]="SidePanelFilterListMode.View"
                            [loading]="filtersLoading()"
                            [canEdit]="canEdit"
                            [dataModel]="contentDataModel()"
                            [(filters)]="filters"
                            [visualInteractions]="visualInteractions"
                            (resetClick)="filtersResetClick()"
                            (editClick) ="filtersEditClick()"></side-panel-filter-list>
    <div sidePanelCollapsed>
      @if (filtersAvailable()) {
        <span class="side-panel-vertical-text user-select-none p-absolute ot-20 mt-10">
          @if (filtersAvailable() && filtersLoading()) {
            <loading-rect size="20px 80px" class="d-inline-block"></loading-rect>
          }
          @else {
            <span [class.opacity-50]="!filtersAvailable()">Filters ({{filters().length}})</span>
          }
        </span>
      }
    </div>
  </side-panel>

  <div class="content-container content-container-expand--with-footer overflow-hidden">
    <div class="container-box p-relative w-100p h-100p bgc-white border-box">
      <app-spinner *ngIf="loading"></app-spinner>
      <div [hidden]="loading" class="w-100p h-100p">
        <ng-container *ngIf="anyHomeItem; else whenNoHomeDashboards">
          @if (dashboard) {
          <dashboard-embed [dashboardDto]="dashboard"
                           [focused]="dashboardFocused()"
                           (focusedChange)="onDashboardFocusedChange($event)"
                           [visualInteractions]="visualInteractions"
                           #dashboardEmbed></dashboard-embed>
          }
          @else if (visual) {
          <visual-embed [visualDto]="visual"
                        [showFocusToggle]="true"
                        [focused]="visualFocused()"
                        (focusedChange)="onVisualFocusedChange($event)"></visual-embed>
          }
        </ng-container>
        <ng-template #whenNoHomeDashboards>
          <div class="d-flex flex-dir-column align-items-center justify-content-center mt-150">
            <img class="mb-50 dashboards-view__empty-image" src="/assets/img/home-dashboard-145h.png" alt="" style="position: relative; left: 26px" />
            <h1 class="c-blue fs-26 bold mb-40">Add to Home</h1>
            <div *ngIf="dashboards?.length">
              <p class="fs-16 mt-0 mb-40">You currently have no dashboards or visuals added to home, please select from the available items below:</p>
              <div class="no-dashboards__dropdowns">
                <div class="no-dashboards__dropdown-wrapper text-center">
                  <label>Library Dashboards</label>
                  <mat-select
                    class="trg-outline w-100p h-32 text-left"
                    (selectionChange)="addDashboardToHome($event.value)"
                    panelClass="trg-outline"
                    placeholder="Please Select"
                    [disabled]="busy"
                    disableOptionCentering
                  >
                    <mat-option *ngFor="let d of libraryDashboards" [value]="d.id">
                      <div class="dropdown-text">
                        <span class="dropdown-text-span">{{ d.name }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </div>
                <div *ngIf="userDashboards.length" class="no-dashboards__separator"></div>
                <div *ngIf="userDashboards.length" class="no-dashboards__dropdown-wrapper text-center">
                  <label>My Dashboards</label>
                  <mat-select
                    class="trg-outline w-100p h-32 text-left"
                    (selectionChange)="addDashboardToHome($event.value)"
                    panelClass="trg-outline trg-outline-dropdown ot-32"
                    placeholder="Please Select"
                    [disabled]="busy"
                    disableOptionCentering
                  >
                    <mat-option *ngFor="let d of userDashboards" [value]="d.id">
                      <div class="dropdown-text">
                        <span class="dropdown-text-span">{{ d.name }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </div>
              </div>
              <div class="no-dashboards__dropdowns">
                <div class="no-dashboards__dropdown-wrapper text-center">
                  <label>Library Visuals</label>
                  <mat-select
                    class="trg-outline w-100p h-32 text-left"
                    (selectionChange)="addVisualToHome($event.value)"
                    panelClass="trg-outline"
                    placeholder="Please Select"
                    [disabled]="busy"
                    disableOptionCentering
                  >
                    <mat-option *ngFor="let v of libraryVisuals" [value]="v.id">
                      <div class="dropdown-text">
                        <span class="dropdown-text-span">{{ v.name }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </div>
                <div *ngIf="userVisuals.length" class="no-dashboards__separator"></div>
                <div *ngIf="userVisuals.length" class="no-dashboards__dropdown-wrapper text-center">
                  <label>My Visuals</label>
                  <mat-select
                    class="trg-outline w-100p h-32 text-left"
                    (selectionChange)="addVisualToHome($event.value)"
                    panelClass="trg-outline trg-outline-dropdown ot-32"
                    placeholder="Please Select"
                    [disabled]="busy"
                    disableOptionCentering
                  >
                    <mat-option *ngFor="let v of userVisuals" [value]="v.id">
                      <div class="dropdown-text">
                        <span class="dropdown-text-span">{{ v.name }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
            <div class="text-center" *ngIf="!dashboards?.length">
              <p class="fs-16 mt-0 mb-40">You currently have no dashboards added to home. Click below to create one:</p>
              <button trgButton color="primary" class="fs-18 px-50 min-h-40" [disabled]="busy">
                <i class="far fa-plus-circle fs-16 mr-6"></i>
                <span>Add a Dashboard</span>
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</app-content-wrapper>
